import components from '../../components'

import palette from 'theme/palette'
import helpers from '../helpers'

import { GAP } from '../../constants'

const diagnostic = async ({ pdf, date, customThemeStatus, departmentData }) => {
  pdf.addPage('a4', 'p')

  components.subtitle(pdf, 'Treinamentos', GAP)

  const departmentChartData = departmentData.map((department) => ({
    name: department.name,
    percentage: department.completedCertificatesPercentage,
  }))

  const peopleChartData = departmentData.map((department) => {
    const certifiedCount = department.certifiedPeople
    const totalPeople = department.totalUsers

    const percentage =
      totalPeople > 0 ? (certifiedCount / totalPeople) * 100 : 0

    const fractionText = `${certifiedCount} / ${totalPeople}`

    return {
      name: department.name,
      percentage: Math.round(percentage),
      fractionText: fractionText,
    }
  })

  components.lineWithDate(pdf, date)

  const finalY = helpers.progressBar(
    pdf,
    'Departamento com a maior porcentagem de certificados',
    departmentChartData,
    GAP * 2,
  )

  helpers.progressBar(
    pdf,
    'Pessoas certificadas por departamento',
    peopleChartData,
    finalY + 40,
  )

  components.numberPage(pdf, palette.primary.main, customThemeStatus)
}

export default diagnostic
